<template>
<div class="chapter">
<div class="inner_page">
<div class="div_autre">
<div class="pre" id="pre-001">
<h1 class="pre_tit"><span><a id="page_VIII"></a><a class="renvlnk" id="renv-viii">THE DATES OF KINGS AND PROPHETS</a></span></h1><a class="renvlnk" id="renv-viii">
</a><div class="dev"><a class="renvlnk" id="renv-viii">
<p class="txt_courant_ssalinea">The dates of the kings of Israel and Judah are disputed. One view of the chronology is given in <i>IBD </i>I, pp. 268–77, in which the authors follow the concept of co-regencies proposed by E. R. Thiele, <i>The Mysterious Numbers of the Hebrew Kings </i>(Grand Rapids: Eerdmans, 1965). Not all scholars are convinced by this solution, and commentators on the prophetic books often accept that dates can only be approximate. The dates adopted in the present volume follow J. Bright, <i>A History of Israel </i>(London: SCM, 1972, second edition) which is largely based in turn on W. F. Albright in <i>BASOR </i>100 (1945), pp. 20–22. In the table below, no account is taken of co-regencies, although these may be needed to solve some problems (for example, see Bright, p. 271, n. 8, on the twenty years given to Pekah in 2 Kgs 15:27).</p>
<div class="niv2" id="niv2-001">
<h3 class="int_niv2">BEFORE THE EXILE</h3>
<div class="tableau" id="Tab1pviii">
<div class="table-align">
<table border="0" cellpadding="5" cellspacing="0">
<colgroup>
<col width="20%"/>
<col width="20%"/>
<col width="20%"/>
<col width="20%"/>
<col/>
</colgroup>
<tbody>
<tr valign="top">
<td class="border_all" colspan="2" valign="top"><p class="txt_courant"><b>Kings of Israel</b></p></td>
<td class="border_all" colspan="2" valign="top"><p class="txt_courant"><b>Kings of Judah</b></p></td>
<td class="border_all" valign="top"><p class="txt_courant"><b>Prophets</b></p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">Jeroboam II</p></td>
<td valign="top"><p class="txt_courant">786–746</p></td>
<td class="border_left" valign="top"><p class="txt_courant">Uzziah</p></td>
<td valign="top"><p class="txt_courant">783–742</p></td>
<td class="border_cote" valign="top"><p class="txt_courant">Amos (Jonah)</p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">Zechariah</p></td>
<td valign="top"><p class="txt_courant">746–745</p></td>
<td class="border_left" valign="top"><p class="txt_courant"> </p></td>
<td valign="top"><p class="txt_courant"> </p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">Shallum</p></td>
<td valign="top"><p class="txt_courant">745</p></td>
<td class="border_left" valign="top"><p class="txt_courant"> </p></td>
<td valign="top"><p class="txt_courant"> </p></td>
<td class="border_cote" valign="top"><p class="txt_courant">Hosea</p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">Menahem</p></td>
<td valign="top"><p class="txt_courant">745–738</p></td>
<td class="border_left" valign="top"><p class="txt_courant">Jotham</p></td>
<td valign="top"><p class="txt_courant">742–735</p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">Pekahiah</p></td>
<td valign="top"><p class="txt_courant">738–737</p></td>
<td class="border_left" valign="top"><p class="txt_courant"> </p></td>
<td valign="top"><p class="txt_courant"> </p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">Pekah</p></td>
<td valign="top"><p class="txt_courant">737–732</p></td>
<td class="border_left" valign="top"><p class="txt_courant">Ahaz</p></td>
<td valign="top"><p class="txt_courant">735–715</p></td>
<td class="border_cote" valign="top"><p class="txt_courant">Isaiah, Micah</p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">Hoshea</p></td>
<td valign="top"><p class="txt_courant">732–722</p></td>
<td class="border_left" valign="top"><p class="txt_courant"> </p></td>
<td valign="top"><p class="txt_courant"> </p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant"> </p></td>
<td valign="top"><p class="txt_courant"> </p></td>
<td class="border_left" valign="top"><p class="txt_courant">Hezekiah</p></td>
<td valign="top"><p class="txt_courant">715–687</p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant"> </p></td>
<td valign="top"><p class="txt_courant"> </p></td>
<td class="border_left" valign="top"><p class="txt_courant">Manasseh</p></td>
<td valign="top"><p class="txt_courant">687–642</p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant"> </p></td>
<td valign="top"><p class="txt_courant"> </p></td>
<td class="border_left" valign="top"><p class="txt_courant">Amon</p></td>
<td valign="top"><p class="txt_courant">642–640</p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant"> </p></td>
<td valign="top"><p class="txt_courant"> </p></td>
<td class="border_left" valign="top"><p class="txt_courant">Josiah</p></td>
<td valign="top"><p class="txt_courant">640–609</p></td>
<td class="border_cote" valign="top"><p class="txt_courant">Habakkuk, Nahum</p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant"> </p></td>
<td valign="top"><p class="txt_courant"> </p></td>
<td class="border_left" valign="top"><p class="txt_courant"></p></td>
<td valign="top"><p class="txt_courant"> </p></td>
<td class="border_cote" valign="top"><p class="txt_courant">Zephaniah</p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant"> </p></td>
<td valign="top"><p class="txt_courant"> </p></td>
<td class="border_left" valign="top"><p class="txt_courant">Jehoahaz</p></td>
<td valign="top"><p class="txt_courant">609</p></td>
<td class="border_cote" valign="top"><p class="txt_courant">Jeremiah</p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant"> </p></td>
<td valign="top"><p class="txt_courant"> </p></td>
<td class="border_left" valign="top"><p class="txt_courant">Jehoiakim</p></td>
<td valign="top"><p class="txt_courant">609–597</p></td>
<td class="border_cote" valign="top"><p class="txt_courant">Obadiah</p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant"> </p></td>
<td valign="top"><p class="txt_courant"> </p></td>
<td class="border_left" valign="top"><p class="txt_courant">Jehoiachin</p></td>
<td valign="top"><p class="txt_courant">597</p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_bas border_left" valign="top"><p class="txt_courant"> </p></td>
<td class="border_bas" valign="top"><p class="txt_courant"> </p></td>
<td class="border_bas border_left" valign="top"><p class="txt_courant">Zedekiah</p></td>
<td class="border_bas" valign="top"><p class="txt_courant">597–587</p></td>
<td class="border_cote border_bas" valign="top"><p class="txt_courant">Ezekiel</p></td>
</tr>
</tbody>
</table>
</div>
</div>
<p class="txt_courant_ssalinea">For different versions of the chronology of the Kings of Judah from Uzziah to Hezekiah see F. I. Andersen and D. N. Freedman, <i>Micah </i>(AB; New York: Doubleday, 2000), p. xviii.</p>
<p class="bl"> </p>
<p class="txt_courant_ssalinea">In the table below the prophets are aligned only approximately with the kings, for ready reference. The table should be used with reference to the discussions of the Date and Destination of the individual prophets. (Jonah and Daniel are put in brackets for reasons that will become clear in the chapters on those books.)</p>
</div>
</a><div class="niv2" id="niv2-002"><a class="renvlnk" id="renv-viii">
<h3 class="int_niv2">EXILE AND AFTER:<br/>KINGS OF BABYLON AND PERSIA</h3>
</a><p class="txt_courant_ssalinea"><a class="renvlnk" id="renv-viii">(see also </a><span class="renv" href="#/chap5#enc-044" title="Link target outside of Sample">table at Daniel: Date and Destination</span>)</p>
<div class="tableau" id="Tab2pviii">
<div class="table-align">
<table border="0" cellpadding="5" cellspacing="0">
<colgroup>
<col width="25%"/>
<col width="45%"/>
<col/>
</colgroup>
<tbody>
<tr valign="top">
<td class="border_all" colspan="2" valign="top"><p class="txt_courant"><b>Kings of Babylon and Persia</b></p></td>
<td class="border_all" valign="top"><p class="txt_courant"><b>Prophets</b></p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">605–562</p></td>
<td valign="top"><p class="txt_courant">Reign of Nebuchadn(r)ezzar</p></td>
<td class="border_cote" valign="top"><p class="txt_courant">(Daniel)</p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">562–560</p></td>
<td valign="top"><p class="txt_courant">Reign of Amel-marduk</p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant"> </p></td>
<td valign="top"><p class="txt_courant">(Evil-Merodach)</p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">560–556</p></td>
<td valign="top"><p class="txt_courant">Reign of Neriglissar</p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">556–539</p></td>
<td valign="top"><p class="txt_courant">Reign of Nabonidus</p></td>
<td class="border_cote" valign="top"><p class="txt_courant">Second Isaiah</p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">549–539</p></td>
<td valign="top"><p class="txt_courant">Belshazzar co-regent</p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">539</p></td>
<td valign="top"><p class="txt_courant">Babylon captured by Cyrus the Persian</p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">539–530</p></td>
<td valign="top"><p class="txt_courant">Reign of Cyrus after capture of Babylon</p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_left" valign="top"><p class="txt_courant">530–522</p></td>
<td valign="top"><p class="txt_courant">Reign of Cambyses</p></td>
<td class="border_cote" valign="top"><p class="txt_courant"> </p></td>
</tr>
<tr valign="top">
<td class="border_bas border_left" valign="top"><p class="txt_courant">522–486</p></td>
<td class="border_bas" valign="top"><p class="txt_courant">Reign of Darius I Hystaspes</p></td>
<td class="border_cote border_bas" valign="top"><p class="txt_courant">Haggai, Zechariah, Malachi</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre2.vue?eae80edc